import { CmmStatus } from "../../../../enums/cmmStatus";

export const getTextColorForCmmStatus = (status: CmmStatus) => {
  if (status === CmmStatus.INVALID_KEY) return "#111111";
  if (status === CmmStatus.INITIATED) return "#665D00";
  if (status === CmmStatus.IN_PROGRESS) return "#7B1FA2";
  if (status === CmmStatus.COMPLETED) return "#005D49";
  if (status === CmmStatus.FAILED) return "#CC0300";
  if (status === CmmStatus.DUPLICATE_KEY) return "#C24400";
  if (status === CmmStatus.PATIENT_MISMATCH) return "#005D49";
  if (status === CmmStatus.ADDITIONAL_QA) return "#0056D6";
  if (status === CmmStatus.STP_FAILED) return "#CC0300";
  if (status === CmmStatus.EXPIRED) return "#A030A0";
  if (status === CmmStatus.NEEDS_API) return "#8A6D00";
  return "#111111";
};
export const getBgColorForCmmStatus = (status: CmmStatus) => {
  if (status === CmmStatus.INVALID_KEY) return "#F5F5F5";
  if (status === CmmStatus.INITIATED) return "#FFFCD6";
  if (status === CmmStatus.IN_PROGRESS) return "#F3E5F5";
  if (status === CmmStatus.COMPLETED) return "#E6F3F0";
  if (status === CmmStatus.FAILED) return "#FFE8E8";
  if (status === CmmStatus.DUPLICATE_KEY) return "#FFF3E6";
  if (status === CmmStatus.PATIENT_MISMATCH) return "#E6F3F0";
  if (status === CmmStatus.ADDITIONAL_QA) return "#E6F0FF";
  if (status === CmmStatus.STP_FAILED) return "#FFE8E8";
  if (status === CmmStatus.EXPIRED) return "#F5EBFF";
  if (status === CmmStatus.NEEDS_API) return "#FFF8E1";
  return "#F5F5F5";
};

export const getTextForCmmStatus = (status: CmmStatus) => {
  if (status === CmmStatus.INVALID_KEY) return "Invalid Key";
  if (status === CmmStatus.INITIATED) return "Started";
  if (status === CmmStatus.IN_PROGRESS) return "In Progress";
  if (status === CmmStatus.COMPLETED) return "Success";
  if (status === CmmStatus.FAILED) return "Error";
  if (status === CmmStatus.DUPLICATE_KEY) return "Duplicate Key";
  if (status === CmmStatus.PATIENT_MISMATCH) return "Patient Mismatch";
  if (status === CmmStatus.ADDITIONAL_QA) return "Additional QA";
  if (status === CmmStatus.STP_FAILED) return "STP Failed";
  if (status === CmmStatus.EXPIRED) return "Expired";
  if (status === CmmStatus.NEEDS_API) return "Needs Refetch";
  return "Invalid Key";
};

export const getCmmStatuS = (
  status: string,
): { text: string; color: string; bgColor: string } => {
  if (status === CmmStatus.INVALID_KEY) {
    return {
      text: getTextForCmmStatus(CmmStatus.INVALID_KEY),
      color: getTextColorForCmmStatus(CmmStatus.INVALID_KEY),
      bgColor: getBgColorForCmmStatus(CmmStatus.INVALID_KEY),
    };
  }
  if (status === CmmStatus.COMPLETED) {
    return {
      text: getTextForCmmStatus(CmmStatus.COMPLETED),
      color: getTextColorForCmmStatus(CmmStatus.COMPLETED),
      bgColor: getBgColorForCmmStatus(CmmStatus.COMPLETED),
    };
  }
  if (status === CmmStatus.FAILED) {
    return {
      text: getTextForCmmStatus(CmmStatus.FAILED),
      color: getTextColorForCmmStatus(CmmStatus.FAILED),
      bgColor: getBgColorForCmmStatus(CmmStatus.FAILED),
    };
  }
  if (status === CmmStatus.INITIATED) {
    return {
      text: getTextForCmmStatus(CmmStatus.INITIATED),
      color: getTextColorForCmmStatus(CmmStatus.INITIATED),
      bgColor: getBgColorForCmmStatus(CmmStatus.INITIATED),
    };
  }
  if (status === CmmStatus.IN_PROGRESS) {
    return {
      text: getTextForCmmStatus(CmmStatus.IN_PROGRESS),
      color: getTextColorForCmmStatus(CmmStatus.IN_PROGRESS),
      bgColor: getBgColorForCmmStatus(CmmStatus.IN_PROGRESS),
    };
  }
  if (status === CmmStatus.DUPLICATE_KEY) {
    return {
      text: getTextForCmmStatus(CmmStatus.DUPLICATE_KEY),
      color: getTextColorForCmmStatus(CmmStatus.DUPLICATE_KEY),
      bgColor: getBgColorForCmmStatus(CmmStatus.DUPLICATE_KEY),
    };
  }
  if (status === CmmStatus.PATIENT_MISMATCH) {
    return {
      text: getTextForCmmStatus(CmmStatus.PATIENT_MISMATCH),
      color: getTextColorForCmmStatus(CmmStatus.PATIENT_MISMATCH),
      bgColor: getBgColorForCmmStatus(CmmStatus.PATIENT_MISMATCH),
    };
  }
  if (status === CmmStatus.ADDITIONAL_QA) {
    return {
      text: getTextForCmmStatus(CmmStatus.ADDITIONAL_QA),
      color: getTextColorForCmmStatus(CmmStatus.ADDITIONAL_QA),
      bgColor: getBgColorForCmmStatus(CmmStatus.ADDITIONAL_QA),
    };
  }
  if (status === CmmStatus.STP_FAILED) {
    return {
      text: getTextForCmmStatus(CmmStatus.STP_FAILED),
      color: getTextColorForCmmStatus(CmmStatus.STP_FAILED),
      bgColor: getBgColorForCmmStatus(CmmStatus.STP_FAILED),
    };
  }
  if (status === CmmStatus.EXPIRED) {
    return {
      text: getTextForCmmStatus(CmmStatus.EXPIRED),
      color: getTextColorForCmmStatus(CmmStatus.EXPIRED),
      bgColor: getBgColorForCmmStatus(CmmStatus.EXPIRED),
    };
  }
  if (status === CmmStatus.NEEDS_API) {
    return {
      text: getTextForCmmStatus(CmmStatus.NEEDS_API),
      color: getTextColorForCmmStatus(CmmStatus.NEEDS_API),
      bgColor: getBgColorForCmmStatus(CmmStatus.NEEDS_API),
    };
  }

  return {
    text: "Not Started",
    color: "#FFFFFF",
    bgColor: "#111111",
  };
};
